export const MAX_ROTATION_ANGLE = 360;
export const MIN_ROTATION_ANGLE = 0;
export const UNPOSSIBLE_ROTATION_ANGLE = MAX_ROTATION_ANGLE + 1;
